import { Input } from 'common/components/Forms/Inputs/Input'
import React, { Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { IJobsListQuery } from './CommunityJobs'
import { CommunityJobsFiltersDialog } from './CommunityJobsFiltersDialog'
interface IProps {
  query: IJobsListQuery
  setQuery: Dispatch<SetStateAction<IJobsListQuery>>
  isLoading: boolean
}
export const CommunityJobsMobileFilters = ({ query, setQuery, isLoading }: IProps) => {
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => setQuery((c) => ({ ...c, search: e.target.value }))

  return (
    <Div className="flex align-items-center gap-1 w-full">
      <Input
        value={query.search || ''}
        icon="pi pi-search"
        onChange={onSearch}
        placeholder="Search by job title, position or company"
        className="flex-1"
      />

      <CommunityJobsFiltersDialog isLoading={isLoading} query={query} setQuery={setQuery} />
    </Div>
  )
}

export const Div = styled.div``
